<div class="create-time-schedule-result">
  <div class="create-time-schedule-result__name">
    <label>{{ 'CREATE_SCHEDULE.TITLE' | translate }}</label>
    <input
      class="ui-input"
      [formControl]="nameControl"
      [placeholder]="'CREATE_SCHEDULE.UNTITLED' | translate"
    />
  </div>

  <ui-time-schedule
    [initialSchedule]="initialSchedule"
    (onScheduleChanged)="onScheduleChanged($event)"
  ></ui-time-schedule>
</div>
